import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import ButtonSecondary from 'components/shared/Button/SecondaryButton';
import {
  SITE_MASTER_COLORS,
  StSiteMasterSection,
  StSiteMasterSectionTitle,
} from 'components/SiteMaster/SiteMaster.styles';
import { getFieldValue } from 'components/SiteMaster/utils';
import { useSiteRecruitingStudiesProps } from 'components/SiteMaster/utils';
import { useTheme } from '@mui/material/styles';

type ExploreStudiesProps = ComponentProps & {
  fields: {
    sectionTitle?: Field<string>;
    sectionDescription?: Field<string>;
    viewAllStudiesButtonText?: Field<string>;
  };
};

const ExploreStudies = (props: ExploreStudiesProps): JSX.Element | null => {
  const theme = useTheme();
  // Single owner: SiteRecruitingStudies getStaticProps
  const { hasRecruitingStudies } = useSiteRecruitingStudiesProps();

  if (!hasRecruitingStudies) {
    return null;
  }

  const sectionTitle = getFieldValue(props.fields.sectionTitle);
  const sectionDescription = getFieldValue(props.fields.sectionDescription);
  const viewAllStudiesButtonText = getFieldValue(props.fields.viewAllStudiesButtonText);

  return (
    <StSiteMasterSection
      id="explore-studies-card"
      sx={{ backgroundColor: SITE_MASTER_COLORS.accentSurface, borderRadius: '24px' }}
    >
      {sectionTitle ? (
        <StSiteMasterSectionTitle
          sx={{
            fontFamily: `${theme.palette.secondaryFontFamilyType}, serif`,
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '100%',
            letterSpacing: 0,
            marginBottom: '12px',
          }}
        >
          <Text field={props.fields.sectionTitle} />
        </StSiteMasterSectionTitle>
      ) : null}

      {sectionDescription ? (
        <Text
          tag="p"
          field={props.fields.sectionDescription}
          style={{ marginBottom: 20, lineHeight: 1.4, fontSize: 14 }}
        />
      ) : null}

      {viewAllStudiesButtonText ? (
        <ButtonSecondary style={{ width: '100%' }}>
          <Text field={props.fields.viewAllStudiesButtonText} />
        </ButtonSecondary>
      ) : null}
    </StSiteMasterSection>
  );
};

export default ExploreStudies;
